<template>
  <div dir="rtl">
    <div class="container">
      <div class="row">
        <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
          <div class="card card-signin my-5">
            <div class="card-body">
              <!-- <h5 class="card-title text-center">ورود پزشک</h5> -->
              <form class="form-signin">
                <div class="logo">
                </div>
                <div class="form-label-group">
                  <input type="text" v-model="councilNo" id="councilNo" class="form-control" placeholder="شماره نظام پزشکی" required autofocus>
                  <label for="councilNo">شماره نظام پزشکی</label>
                </div>
                <div class="form-label-group">
                  <input type="password" v-model="nationalCode" id="nationalCode" class="form-control" placeholder="کد ملی" required>
                  <label for="nationalCode">کد ملی</label>
                </div>
                <img id="img-captcha" :src="captchaData" />
                <div class="form-label-group">
                  <input type="text" v-model="captcha" id="captcha" class="form-control" placeholder="کد امنیتی" required>
                  <label for="captcha">کد امنیتی</label>
                </div>
                <span v-if="fieldError" class="error mt-2">لطفا همه فیلدها را پر کنید.</span>
                <span v-if="captchaError" class="error mt-2">کد امنیتی اشتباه است</span>
                <button class="btn btn-lg btn-primary btn-block text-uppercase" @click="doCheck">ادامه</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'check-member',
  data () {
    return {
      captchaData: '',
      councilNo: '',
      nationalCode: '',
      captcha: '',
      captchaError: false,
      fieldError: false
    }
  },
  methods: {
    loadCaptcha () {
      let url = this.$root.apiUrl + '/Members/captcha'
      this.$http
        .get(url)
        .then(res => {
          this.captchaData = 'data:image/Png;base64,' + res.data
        })
        .catch(err => {
          console.error(err)
        })
    },
    doCheck () {
      if (!(this.captcha.length && this.councilNo.length && this.nationalCode.length)) {
        this.fieldError = true
        return
      }
      const info = `councilNo=${this.councilNo}&nationalCode=${this.nationalCode}&captcha=${this.captcha}`
      const url = this.$root.apiUrl + '/members/checkmember'
      this.$http
        .post(url, info, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          withCredentials: true
        })
        .then(res => {
          if (res.data) {
            res.data.licenseExportDate = this.$root.toPersianDate(res.data.licenseExportDate)
            res.data.licenseExpireDate = this.$root.toPersianDate(res.data.licenseExpireDate)
            this.$root.member = res.data
            delete this.$root.member.id
            delete this.$root.member.fullname
            delete this.$root.member.clientIp
            delete this.$root.member.saveMoment
            this.$router.replace('/register')
          } else {
            alert('خطا در ارتباط با سرور')
          }
        })
        .catch(err => {
          console.info(err)
          if (err.response) {
            if (err.response.status === 400) {
              this.$root.member = null
              this.$router.replace('/register')
            } else if (err.response === 403) {
              this.captchaError = true
              this.captcha = ''
            }
          }
        })
    }
  },
  mounted () {
    this.loadCaptcha()
  }
}
</script>

<style scoped>

body {
  background: #007bff;
  background: linear-gradient(to right, #0062E6, #33AEFF);
}

.logo {
  background: url('../assets/bndmc.png') center no-repeat;
  background-size: contain;
  min-height: 200px;
  height: 25vh;
  margin-bottom: 10px;
}

.card-signin {
  border: 0;
  border-radius: 1rem;
  box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.1);
}

.card-signin .card-title {
  margin-bottom: 2rem;
  font-weight: 300;
  font-size: 1.5rem;
}

.card-signin .card-body {
  padding: 2rem;
}

.form-signin {
  width: 100%;
}

.form-signin .btn {
  font-size: 80%;
  border-radius: 5rem;
  letter-spacing: .1rem;
  font-weight: bold;
  padding: 1rem;
  transition: all 0.2s;
}

.form-label-group {
  position: relative;
  margin-bottom: 1rem;
}

.form-label-group input {
  height: auto;
  border-radius: 2rem;
}

.form-label-group>input,
.form-label-group>label {
  padding: var(--input-padding-y) var(--input-padding-x);
}

.form-label-group>label {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  margin-bottom: 0;
  /* Override default `<label>` margin */
  line-height: 1.5;
  color: #495057;
  border: 1px solid transparent;
  border-radius: .25rem;
  transition: all .1s ease-in-out;
}

.form-label-group input::-webkit-input-placeholder {
  color: transparent;
}

.form-label-group input:-ms-input-placeholder {
  color: transparent;
}

.form-label-group input::-ms-input-placeholder {
  color: transparent;
}

.form-label-group input::-moz-placeholder {
  color: transparent;
}

.form-label-group input::placeholder {
  color: transparent;
}

.form-label-group input:not(:placeholder-shown) {
  padding-top: calc(var(--input-padding-y) + var(--input-padding-y) * (2 / 3));
  padding-bottom: calc(var(--input-padding-y) / 3);
}

.form-label-group input:not(:placeholder-shown)~label {
  padding-top: calc(var(--input-padding-y) / 3);
  padding-bottom: calc(var(--input-padding-y) / 3);
  font-size: 12px;
  color: #777;
}

#img-captcha {
  position: relative;
  margin-right: 25%;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/CheckMember.vue